import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "all", "count", "bar"]

  toggleAll() {
    const checked = this.allTarget.checked
    this.checkboxTargets.forEach((c) => (c.checked = checked))
    this.refresh()
  }

  refresh() {
    const selected = this.checkboxTargets.filter((c) => c.checked)
    const n = selected.length

    if (this.hasCountTarget) this.countTarget.textContent = n
    if (this.hasBarTarget) this.barTarget.classList.toggle("hidden", n === 0)

    if (this.hasAllTarget) {
      this.allTarget.checked = n > 0 && n === this.checkboxTargets.length
      this.allTarget.indeterminate = n > 0 && n < this.checkboxTargets.length
    }
  }
}
